import Section from '../Section';
import QuickAdd from '../global/QuickAdd';

export default class CollectionListSection extends Section {

  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.quickAddButtons = new QuickAdd(theme, element);
  }
}
